import { Pipe } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "./translate.service";
export class TranslatePipe {
    translateService;
    constructor(translateService) {
        this.translateService = translateService;
    }
    transform(key, context) {
        return this.translateService.translate(key, context);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TranslatePipe, deps: [{ token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TranslatePipe, name: "mheTranslate", pure: false });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TranslatePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'mheTranslate', pure: false }]
        }], ctorParameters: function () { return [{ type: i1.TranslateService }]; } });
